const parametrizationReabTimelineHeaders = [
  {
    group: 'Cronograma',
    columns: [
      {
        name: 'tipo',
        id: 'cron-1',
        show: true
      },
      {
        name: 'Centro Distribuição',
        id: 'cron-2',
        show: true
      },
      {
        name: 'Loja',
        id: 'cron-7',
        show: true
      },
      {
        name: 'Dia da Semana Empresa',
        id: 'cron-3',
        show: true
      },
      {
        name: 'Setor',
        id: 'cron-4',
        show: true
      },
      {
        name: 'Previsao Entrega',
        id: 'cron-5',
        show: true
      },
      {
        name: 'Ativo',
        id: 'cron-6',
        show: true
      }
    ]
  }
]

export default parametrizationReabTimelineHeaders
